import country1 from "../../../assets/imgs/country-1.svg";
import country2 from "../../../assets/imgs/country-2.svg";
import country3 from "../../../assets/imgs/country-3.svg";
import country4 from "../../../assets/imgs/country-4.svg";
import country5 from "../../../assets/imgs/country-5.svg";
import country6 from "../../../assets/imgs/country-6.svg";
import country7 from "../../../assets/imgs/country-7.svg";
import country8 from "../../../assets/imgs/country-8.svg";
import country9 from "../../../assets/imgs/country-9.svg";

export const imgs = [
  country1, country2, country3, country4, country5, country6, country7, country8, country9, country1, country2, country3, country4, country5, country6, country7, country8, country9
];
